import React from 'react'
import HardwareBanner from '../Components/hardware/HardwareBanner'
import Hardwares from '../Components/hardware/Hardwares'

const Hardware = () => {
    return (
        <div>
            <HardwareBanner />
            {/* <div style={{ background: '#fff', height: '50vh' }}>
                <h1 style={{ textAlign: 'center', color: '#000219' }}>Hardware</h1>
                <p style={{ color: 'black', margin: '0rem 15rem' }}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi ex beatae laudantium architecto tempore animi in consectetur at, autem, culpa placeat explicabo, odio iure adipisci iusto ipsum obcaecati dolorem enim aut assumenda eum molestiae tempora soluta illo. Quod libero provident esse maiores doloremque deleniti suscipit!</p>
            </div> */}
            <Hardwares />
        </div>
    )
}

export default Hardware
